import Swal from "sweetalert2"
import faradayApi from "../../api/faradayApi"


export const createConfirmEvent = async (formValues, succesMsg, errorMsg, errorNameDup) => {
    try {
        const { data } = await faradayApi.post(`/eventRegister`, formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        if (error.response.data.msg.original.code === 'ER_DUP_ENTRY') {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorNameDup,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: error,
                icon: "error",
                iconColor: '#FF7765'
            })
        }
    }
}

export const editConfirmEvent = async (formValues, succesMsg, errorMsg, errorNameDup) => {
    try {
        const { data } = await faradayApi.put(`/eventRegister/editByUser`, formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        if (error.response.data.msg.original.code === 'ER_DUP_ENTRY') {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorNameDup,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: error,
                icon: "error",
                iconColor: '#FF7765'
            })
        }
    }
}